import { createFileRoute } from "@tanstack/react-router";
import { AlternatingShowcase } from "~/components/4_modules/AlternatingShowcase";
import { Hero } from "~/components/4_modules/Hero";
import { ImageBanner } from "~/components/4_modules/ImageBanner";
import StandardSection from "~/components/4_modules/StandardSection";
import { SEO } from "~/components/SEO";
import { organizationSchema } from "~/lib/structured-data";

const aboutContent = {
  hero: {
    backgroundImage: "/images/chi-siamo-hero.webp",
    title: "Chi siamo",
  },
  intro: {
    title: "Una passione di famiglia",
    paragraph: [
      "Siamo Mattia, Sara ed Elena: marito, moglie e cognata uniti dalla passione per la ristorazione e l’ospitalità.",
    ],
  },
};

export const Route = createFileRoute("/about")({
  component: About,
});

function About() {
  return (
    <>
      <SEO
        title="Chi Siamo"
        socialTitle="Ristorante Tennis & Gourmet Morbegno | Chi Siamo"
        description="Scopri la storia di Tennis Gourmet: un ristorante di pesce e centro sportivo nel cuore della Valtellina. La nostra passione per la cucina e lo sport dal 1985."
        keywords="storia Tennis Gourmet, ristorante Morbegno storia, centro sportivo Valtellina, chi siamo"
        url="https://www.ristorantetennisgourmet.it/about"
        image="/images/chi-siamo-hero.webp"
        structuredData={organizationSchema}
      />
      {/* Hero Section */}
      <Hero backgroundImage={aboutContent.hero.backgroundImage}>
        <h2 className="tg-h1 font-medium uppercase">{aboutContent.hero.title}</h2>
      </Hero>
      {/* Intro Section */}
      <StandardSection
        sectionClass="pb-10 xl:pb-0"
        paragraphClasses="max-w-[60vw] md:max-w-[40vw] xl:max-w-none"
        title={aboutContent.intro.title}
        paragraph={aboutContent.intro.paragraph}
        decors={[
          <img
            key="decor-1"
            src="/images/decor/decor-02L.webp"
            alt="page decoration"
            className="absolute bottom-0 left-0 hidden h-auto object-cover xl:block xl:w-[15vw]"
          />,
          <img
            key="decor-2"
            src="/images/decor/decor-03.webp"
            alt="page decoration"
            className="absolute right-0 bottom-0 h-auto w-[40vw] object-cover md:w-[30vw] xl:top-0 xl:w-[15vw]"
          />,
        ]}
      ></StandardSection>
      {/* Image Banner */}
      <ImageBanner
        src={{
          mobile: "/images/banner-chef-quote--mobile.webp",
          desktop: "/images/banner-chef-quote.webp",
        }}
        alt="External picture of chef cutting salmon"
        children={
          <div className="flex h-full flex-col items-center justify-center text-center">
            <p className="tg-body">
              La nostra filosofia si ispira<br className="xl:hidden"></br> alle parole
              dello chef Heinz Beck:
            </p>
            <h2 className="tg-h3">
              “La cucina non è mangiare.<br></br>È molto, molto di più.<br></br>Cucina è
              poesia.”
            </h2>
          </div>
        }
      />
      <AlternatingShowcase
        items={[
          {
            title: "Mattia",
            description: (
              <p>
                Cuoco da quasi 20 anni, ha trasformato la sua passione in professione.
                Diplomato alla scuola alberghiera di Crotto Caurga, ha conseguito nel
                maggio 2023 il diploma di sommelier professionista AIS, ampliando la sua
                competenzaanche nel mondo dei vini e dei distillati.
              </p>
            ),
            image: { src: "/images/team-01.webp", alt: "Mattia", alignment: "top" },
          },
          {
            title: "Sara",
            description: (
              <p>
                Laureata in biologia molecolare, affianca però Mattia nella gestione del
                ristorante da quasi 10 anni. Condivide con lui l’amore per il vino,
                culminato anch’esso nel diploma di sommelier professionista AIS ottenuto
                nel maggio 2023.
              </p>
            ),
            image: { src: "/images/team-02.webp", alt: "Sara", alignment: "top" },
          },
          {
            title: "Elena",
            description: (
              <p>
                L’ultima entrata in società, è il volto sorridente che vi accoglie
                all’ingresso, assicurandosi che ogni ospite si senta come a casa
              </p>
            ),
            image: { src: "/images/team-03.webp", alt: "Elena", alignment: "top" },
          },
        ]}
      />
    </>
  );
}
